import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@safetyhub/ui';
import { authApi, extractApiError } from '../lib/api';

export default function PasswordResetRequest() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await authApi.requestPasswordReset(email);

      if (response.success && response.data) {
        setSuccess(true);
      } else {
        setError(response.error?.message || '요청 처리 중 오류가 발생했습니다.');
      }
    } catch (err) {
      const apiError = extractApiError(err);
      setError(apiError.message);
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900">
        <div className="bg-white p-8 rounded-card-lg shadow-xl w-full max-w-md">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
              <svg className="h-6 w-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">재설정 링크 발송 완료</h2>
            <p className="text-gray-600 mb-4">
              입력하신 이메일로 비밀번호 재설정 링크가 발송되었습니다.
            </p>
            <p className="text-sm text-gray-500 mb-6">
              이메일의 링크를 클릭하면 SMS 인증 후 비밀번호를 변경할 수 있습니다.
            </p>
            <Link
              to="/login"
              className="text-red-600 hover:text-red-700 font-medium"
            >
              로그인으로 돌아가기
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="bg-white p-8 rounded-card-lg shadow-xl w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-gray-900">비밀번호 재설정</h1>
          <p className="text-sm text-gray-600 mt-2">
            등록된 이메일 주소를 입력하세요
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {error && (
            <div className="p-3 bg-red-50 border border-red-200 rounded text-red-600 text-sm">
              {error}
            </div>
          )}

          <div className="bg-brand-50 border border-brand-200 rounded p-3">
            <p className="text-sm text-brand-800">
              <strong>인증 절차 안내:</strong> 이메일 링크 클릭 후, SMS 인증을 통해 비밀번호를 변경합니다.
            </p>
          </div>

          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
              이메일
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              placeholder="admin@example.com"
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-control shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500"
            />
          </div>

          <Button type="submit" variant="primary" size="lg" disabled={loading} className="w-full">
            {loading ? '발송 중...' : '재설정 링크 발송'}
          </Button>

          <div className="text-center">
            <Link
              to="/login"
              className="text-sm text-gray-600 hover:text-gray-900"
            >
              로그인으로 돌아가기
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
